import { EventEmitter } from 'events';

export function showNotification(options) {
  EventEmitter.prototype.emit(
    'showNotification', options
  );
}

export function removeNotification(uid) {
  EventEmitter.prototype.emit('removeNotification', uid);
}
